
class ProcessRequestExecutionStateStatistics {
    total: number;
    succeeded: number;
    failed: number;
    isFinished: boolean;
    isEmpty: boolean;

    constructor(data: ProcessRequestExecutionStateStatistics) {
        Object.assign(this, data);
    }

    get ratio(): number {
        if (this.total === 0) return 0;
        return (this.succeeded + this.failed) / this.total;
    }

    get percentage(): number {
        return this.ratio * 100;
    }


}

export default ProcessRequestExecutionStateStatistics;